import PropTypes from 'prop-types';
import React from 'react';
import { FormControl } from 'react-bootstrap';

class InputEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: this.props.initialValue };
    }

    render() {
        const value = this.state.value;
        return (
          <FormControl
            type={this.props.type || 'text'}
            onChange={e => this.setState({
                value: e.target.value,
            })}
            onKeyUp={this.props.onKeyUp ?  this.props.onKeyUp : (e) => {
                if (e.keyCode === 13) {
                    this.props.onValue(value);
                }
            }}
            onBlur={this.props.onBlur ?  this.props.onBlur : e => this.props.onValue(value)}
            onFocus={(e) => {
                const field = e.target;
                const length = field.value.length;
                field.selectionStart = 0;
                field.selectionEnd = length;
            }}
            defaultValue={value}
            standalone
            bsStyle={this.props.bsStyle}
            autoFocus
            {...this.props}
          />
        );
    }
}

InputEditor.propTypes = {
    initialValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onValue: PropTypes.func.isRequired,
    bsStyle: PropTypes.string.isRequired,
};

export default InputEditor;
